import { useGetSettingQuery } from '../../../../Redux/Apis/siteApi'

function Team() {
	const {data : {about: {team : {data,name}}}} = useGetSettingQuery()

    return ( 
        <div className="untree_co-section">
			<div className="container">

				<div className="row mb-5">
					<div className="col-lg-5 mx-auto text-center">
						<h2 className="section-title">{name}</h2>
					</div>
				</div>

				<div className="row">
					{data.lso_team && 
						data.lso_team.map((row,index) => 
						<div className="col-12 col-md-6 col-lg-3 mb-5 mb-md-0" key={index}>
							<img src={row.img_image} className="img-fluid mb-3" alt=''/>
							<h3 className='fw-bold fs-4 text-decoration-underline text-dark'>{row.txt_name}</h3>
							<span className="d-block position mb-4">{row.txt_career}</span>

							<p>{row.txe_bio}</p>
						</div> 
					)}
				</div>
			</div>
		</div>
    );
}

export default Team;